import React from 'react'
import CSSModules from 'react-css-modules'

import styles from './grid-canvas-sync-fix.css'

// Render canvas to keep scrollSync render in sync - https://github.com/bvaughn/react-virtualized/issues/291
const GridCanvasSynxFix = () => (
  <canvas styleName="canvas" />
)

export default CSSModules(GridCanvasSynxFix, styles)



/** WEBPACK FOOTER **
 ** ./src/components/grid/grid-canvas-sync-fix/grid-canvas-sync-fix.js
 **/